import { string, object } from 'yup';

const schema = object().shape({
  mssg: string().required('requiredField')
});

export default schema;